<!--
 * @Description: 
 * @Author: juanjuanhui
 * @Date: 2023-05-17 10:56:39
 * @LastEditors: zhaowh zhaowh@example.com
 * @LastEditTime: 2023-12-05 14:14:14
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  // 除理刷新后清除vuex的問題
  
  created() {
    // qwdnb qwdnbkls
    // 如果sessionStorage中存储了store;
    if (sessionStorage.getItem("store")) {
      // replaceState 替换state根状态(参数为 对象)
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }
    // //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });

    // 解决ERROR ResizeObserver loop completed with undelivered notifications.
    // 问题的
    const debounce = (fn, delay) => {
      let timer = null;
      return function () {
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          fn.apply(context, args);
        }, delay);
      };
    };
    const _ResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
      constructor(callback) {
        callback = debounce(callback, 16);
        super(callback);
      }
    };
  },
};
</script>
<style lang="scss">
html,
body {
  overflow: hidden;
  // background: #001356;
}

#app {
  height: 100vh;
}
.preview-container {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.75);
  .pic {
    width: 1000px;
    height: 600px;
    object-fit: contain;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    right: 0;
    border: 0;
    margin: auto;
  }

  .qxGuanbi {
    width: 18px;
    height: 18px;
    background-color: rgba(0, 0, 0, 0.75);
    color: #fff;
    line-height: 50px;
    text-align: center;
    position: absolute;
    right: 14px;
    top: 14px;
    cursor: pointer;
  }
}
</style>
